import clsx from 'clsx';
import { useFormContext } from 'react-hook-form';

const FormInput = ({ type, className, name, required, ...props }) => {
  const { register } = useFormContext();

  return (
    <input
      {...register(name, { required: required ? 'This field is required' : false })}
      type={type}
      className={clsx(
        'order-1 md:order-2 w-full md:w-auto form-input bg-gray-900 border-0 rounded-md py-3.5 focus:ring-2 focus:ring-white pr-10 text-lg',
        className
      )}
      {...props}
    />
  );
};

export default FormInput;
